import type { NavItems } from '@ksyos/design-system';
import { SideNav } from '@ksyos/design-system';
import { useHasActiveNavigationItem } from '../hooks/useHasActiveNavigationItem';

export type SideNavItemProps = {
    defaultOpenKey?: string;
    item: NavItems;
    onClose: () => void;
};

export function SideNavItem({ item, onClose, defaultOpenKey }: Readonly<SideNavItemProps>) {
    const hasActiveChild = useHasActiveNavigationItem(item.items);

    if (item.items && item.items.length > 0) {
        const { key, items, ...rest } = item;

        return (
            <SideNav.Group
                defaultOpen={key === defaultOpenKey || hasActiveChild}
                key={key}
                {...rest}
            >
                {items.map((subItem: NavItems) => (
                    <SideNavItem
                        item={subItem}
                        key={subItem.key}
                        onClose={onClose}
                    />
                ))}
            </SideNav.Group>
        );
    }

    const { key, onClick, ...rest } = item;

    return (
        <SideNav.Link
            key={key}
            onClick={(event: React.MouseEvent<HTMLAnchorElement> & React.MouseEvent<HTMLButtonElement>) => {
                onClose();
                if (onClick) {
                    onClick(event);
                }
            }}
            {...rest}
        />
    );
}
